// 1688应用的id(branchRelId) 的本地相关操作

import { Service_GetZfbMemberInfo } from "./platform_config";

// orders_branch_relId : {
//   3058519473 :{
//     5:{
//       2462883790:{
//         is: true,
//         relid: 123
//       },
//       2462883790:{
//         is,
//         relid
//       },
//       2462883790:{
//         is,
//         relid
//       },
//       2462883790:{
//         is,
//         relid
//       }
//     }

//   },
//   3058519473: {}
// }

const orders_branch_rel_info = "orders_branch_rel_info";

// 整理获取本地的BranchRelId 的key
export function Service_SetDefaultAppToLocal(shopInfo, appInfo) {
  var info = Service_GetBranchRelInfoToLocal() ? JSON.parse(Service_GetBranchRelInfoToLocal()) : {};
  if (!shopInfo) shopInfo = Service_GetZfbMemberInfo();
  var mallShopId = shopInfo.ShopId || shopInfo.shop_id;
  var AppPlatformType = appInfo.PlatformType;
  var AppShopId = appInfo.ShopId;
  info[mallShopId] = info[mallShopId] || {};
  info[mallShopId][AppPlatformType] = info[mallShopId][AppPlatformType] || {};
  for (var itemAppShopId in info[mallShopId][AppPlatformType]) {
    var item = info[mallShopId][AppPlatformType][itemAppShopId];
    item.isDefault = false;
  }
  console.log("appInfo", appInfo);
  info[mallShopId][AppPlatformType][AppShopId] = {
    isDefault: true,
    relId: appInfo.RelId,
    AuthId: appInfo.RelId,
    ShopId: appInfo.ShopId,
    ShopName: appInfo.ShopName,
  };
  localStorage.setItem(orders_branch_rel_info, JSON.stringify(info));
}

// 获取本地授权branchRelInfo
export function Service_GetBranchRelInfoToLocal() {
  return localStorage.getItem(orders_branch_rel_info);
}

// 找到对应的relId  branchGroupRelId
export function Service_GetBranchRelId(relation, platformType) {
  var info = Service_GetBranchRelInfoToLocal() ? JSON.parse(Service_GetBranchRelInfoToLocal()) : {};
  if (!relation) relation = Service_GetZfbMemberInfo();
  var mallShopId = relation.ShopId || relation.shop_id;
  const PlatformType = platformType || 5; // 目前只有1688 先写死
  var currentAppInfo = {};
  info[mallShopId] = info[mallShopId] || {};
  info[mallShopId][PlatformType] = info[mallShopId][PlatformType] || {};
  for (var key in info[mallShopId][PlatformType]) {
    var item = info[mallShopId][PlatformType][key];
    if (item.isDefault) {
      currentAppInfo = item;
      break;
    }
  }

  return currentAppInfo?.relId || "";
}
export function Service_GetBranchObj(relation, platformType) {
  var info = Service_GetBranchRelInfoToLocal() ? JSON.parse(Service_GetBranchRelInfoToLocal()) : {};
  if (!relation) relation = Service_GetZfbMemberInfo();
  var mallShopId = relation.ShopId || relation.shop_id;
  const PlatformType = platformType || 5; // 目前只有1688 先写死
  var currentAppInfo = {};
  info[mallShopId] = info[mallShopId] || {};
  info[mallShopId][PlatformType] = info[mallShopId][PlatformType] || {};
  for (var key in info[mallShopId][PlatformType]) {
    var item = info[mallShopId][PlatformType][key];
    if (item.isDefault) {
      currentAppInfo = item;
      break;
    }
  }

  return currentAppInfo;
}
